module.exports = __webpack_public_path__ + "img/thumb_aula24.59428368.jpg";